import { Card, Typography } from '@otp/ui';
import React from 'react';
import { MostQuerySuggestedTask } from 'src/graphql/generated/graphql';
import { Schedule } from '@otp/icons';
import styles from './index.module.css';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { RunSchedule } from 'src/components/most/common/run-schedule';
import { DocumentNode } from 'graphql/index';
import popperStyles from './schedule-button.module.css';
import { ClickAwayFadePopper } from '@otp/ui';
import { useMostScheduledJobsFiltered } from 'src/hooks/query/most/use-most-scheduled-job-filtered';

type ActionsColumProps = {
  task: MostQuerySuggestedTask;
  storeId: string;
  refetchQueries?: DocumentNode[];
};

export const ScheduleButton = ({
  task,
  storeId,
  refetchQueries,
}: ActionsColumProps) => {
  const { t } = useTranslation();
  const { triageId } = task.problemDefinition || {};
  const device = task.computersWithProblem?.[0];

  const { data } = useMostScheduledJobsFiltered({
    filter: { commandId: triageId as string, devices: [device as string] },
  });
  const isTriageAlreadyScheduled = !!data?.pagination?.totalCount;

  const element = (
    <RunSchedule
      selectedTask={{
        task,
        storeId,
      }}
      disabledFields={{ action: true }}
      hiddenFields={['callout', 'storeIds', 'devices', 'recurring']}
      title={
        (
          <div className="flex">
            <Schedule className={clsx('mr-2', styles.iconColor)} />
            <Typography variant="subtitle1">
              {t('most.list.schedule.form.title')}
            </Typography>
          </div>
        ) as any
      }
      disabled={isTriageAlreadyScheduled}
      refetchQueries={refetchQueries}
    >
      <Schedule
        className={clsx(styles.icon, {
          [styles.iconDisabled]: isTriageAlreadyScheduled,
        })}
      />
    </RunSchedule>
  );

  return isTriageAlreadyScheduled ? (
    <ClickAwayFadePopper
      popperBody={
        <div>
          <Card className={popperStyles.cardWrapper}>
            {t('most.list.schedule.already-scheduled')}
          </Card>
        </div>
      }
      titleElement={<div className={popperStyles.wrapper}>{element}</div>}
      popper={{ disablePortal: false }}
      fade={{ timeout: 350 }}
    />
  ) : (
    element
  );
};
